import { render, staticRenderFns } from "./PageAdditionalData.vue?vue&type=template&id=10fcf557&scoped=true&"
import script from "./PageAdditionalData.vue?vue&type=script&lang=js&"
export * from "./PageAdditionalData.vue?vue&type=script&lang=js&"
import style0 from "./PageAdditionalData.vue?vue&type=style&index=0&id=10fcf557&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10fcf557",
  null
  
)

export default component.exports